export enum AutoCleanupResult {
  DeletePermanently = "DELETE_PERMANENTLY",
  MoveToTrash = "MOVE_TO_TRASH",
}

export interface AutoCleanupDecision {
  result: AutoCleanupResult | null;
}

export interface AutoCleanupEditorState {
  isReadOnly: boolean;
  isNoteEmpty: boolean;
}

export interface AutoCleanupNoteState {
  isDeleted: boolean;
  isTrashed: boolean;
  isOwnedByMe: boolean;
  isContentLoaded: boolean;
  modelVersion: number;
  hasQueuedUpdates: boolean;
  hasOpenTab: boolean;
}

export interface AutoCleanupRuntimeState {
  isAudioRecordingActive: boolean;
  hasSuggestion: boolean;
  isAutoDeletable: boolean;
  hasSource: boolean;
  hasRecording: boolean;
}

export interface AutoCleanupInput {
  id: string;
  editor: AutoCleanupEditorState;
  note: AutoCleanupNoteState;
  runtime: AutoCleanupRuntimeState;
}
